export default __webpack_public_path__ + "static/media/menu_management.50a01efb.svg";